<template>
  <!--
  We use the Grid Layout based on a GraphQL query
  -->
  <grid-layout :query="require('@/graphql/Studies.gql')" :variables="{}"
               :theme="'orange'"
               :type="'studies'"
               :title-text="'Études'"
               :name-text="'Études'"
               :page-size="pageSize"
  >
    <!--
    And in the Grid Layout, we will need to use this slot
    -->
    <template v-slot:main-section="props">
      <card-study v-for="(info, index) in props.data.studies.edges" :key="index" :study="info"/>
    </template>

  </grid-layout>
</template>

<script>
  import GridLayout from "../components/Layout/GridLayout";
  import CardStudy from "../components/Card/Models/Card-study";

  export default {
    name: "Studies",
    components: {CardStudy, GridLayout},

    data: () => {
      return {
        // par defaut: page 1
        page: 1,
        // nb of items per page
        pageSize: 9,
      }
    },
  }
</script>

<style scoped lang="scss">
  .no-result {
    // padding: rem(30px) rem(30px)
  }
</style>